import LogRocket from 'logrocket';
import React from 'react';
import toast from 'react-hot-toast';
// import { LoadingIndicator } from './LoadingIndicator';

export type ErrorBoundaryProps = {
  name?: string;
  silent?: boolean;
  // children: React.ReactNode | React.ReactNode[];
};

export type ErrorBoundaryState = {
  error: string;
  timeout: NodeJS.Timeout | null;
};

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren<ErrorBoundaryProps>) {
    super(props);
    this.state = { error: '', timeout: null };
  }

  componentDidCatch(error: Error) {
    LogRocket.captureException(error);
    if (this.props.silent) {
      toast.error(
        `An error occurred${
          this.props.name ? ` in "${this.props.name}"` : ''
        }: ${error.name}\nPlease contact support if the issue persists.`,
      );
    }
    this.setState({
      error: `${error.name}: ${error.message}`,
    });
  }

  resetErrorState() {
    this.setState({ error: '', timeout: null });
  }

  render() {
    const { error } = this.state;
    if (error) {
      if (this.props.silent) {
        return null;
      }
      return (
        <div
          className="flex-column w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ margin: 'auto' }}
        >
          <h4 className="text-danger">An error occurred: "{error}"</h4>
          {/* <p>
            We are collecting information about the issue, your session will be
            resumed shortly.
          </p>
          <LoadingIndicator color="" text="" /> */}
          <p className="btn btn-link" onClick={() => this.resetErrorState()}>
            Send report and resume session
          </p>
        </div>
      );
    }
    return <>{this.props.children}</>;
  }
}
